<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-layout justify-center align-center class="auth-layout">
            <v-flex text-center>
                <div v-html="require('!html-loader!@/assets/images/logo_image.svg')" class="d-inline-flex mb-60" />
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="auth-form"
                    @submit.prevent
                >
                    <div class="auth-form__input mb-4">
                        <label for="password" class="main-text"> Пароль </label>
                        <v-text-field
                            v-model="password"
                            id="password"
                            :rules="[rules.required]"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder="Введите пароль"
                            class="dark-input ma-0"
                            dense
                        >
                            <template v-slot:append>
                                <div
                                    v-if="showPassword"
                                    v-html="require('!html-loader!@/assets/icons/eye_icon.svg')"
                                    class="img-form"
                                    @click="showPassword = !showPassword"
                                />
                                <div
                                    v-else
                                    v-html="require('!html-loader!@/assets/icons/eye_closed_icon.svg')"
                                    class="img-form"
                                    @click="showPassword = !showPassword"
                                />
                            </template>
                        </v-text-field>
                    </div>
                    <div class="auth-form__input mb-60">
                        <label for="confirmPassword" class="main-text"> Подтверждение пароля </label>
                        <v-text-field
                            v-model="confirmPassword"
                            id="confirmPassword"
                            :rules="[rules.required, rules.confirm]"
                            :type="showConfirmPassword ? 'text' : 'password'"
                            placeholder="Введите пароль"
                            class="dark-input ma-0"
                            dense
                        >
                            <template v-slot:append>
                                <div
                                    v-if="showConfirmPassword"
                                    v-html="require('!html-loader!@/assets/icons/eye_icon.svg')"
                                    class="img-form"
                                    @click="showConfirmPassword = !showConfirmPassword"
                                />
                                <div
                                    v-else
                                    v-html="require('!html-loader!@/assets/icons/eye_closed_icon.svg')"
                                    class="img-form"
                                    @click="showConfirmPassword = !showConfirmPassword"
                                />
                            </template>
                        </v-text-field>
                    </div>
                    <v-btn
                        :disabled="!valid"
                        class="yellow-btn"
                        type="submit"
                        @click="validate"
                    >
                        Сохранить
                    </v-btn>
                </v-form>
            </v-flex>
        </v-layout>
        <ModalMessage
            v-model="modalOpen"
            text="Токен для подтвержения просрочен или не является валидным"
            text-btn="Хорошо"
            text-center
        />
    </v-container>
</template>

<script>
import ModalMessage from "@/components/modals/ModalMessage";
export default {
    name: 'SetNewPassword',
    components: {ModalMessage},
    data() {
        return {
            password: null,
            confirmPassword: null,
            valid: true,
            showPassword: false,
            showConfirmPassword: false,
            rules: {
                required: value => !!value || 'Обязательное поле',
                confirm: value => value == this.password || 'Пароли не совпадают',
            },
            modalOpen: false,
            token: null,
        };
    },
    created() {
        this.token = this.$route.query.reset_token;
    },
    methods: {
        setPassword() {
            this.$http.put('/users/home/change-password/?reset_token=' + this.token, {
                password: this.password,
            })
                .then(() => {
                    this.$router.push({ name: "login" });
                })
                .catch((error) => {
                    console.error(error);
                    this.modalOpen = true;
                });
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.valid) {
                this.setPassword();
            }
        },
    }
}
</script>

<style scoped>
</style>